import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import * as ReactDOM from 'react-dom'

import '../../Message.css'
import './TemplateMessage.css'
import QuickReplyList from '../../Reply/QuickReplyList'
import { NextIcon, PrevIcon } from '../../../../icons/Icons'
import TemplateSlidesList from './TemplateSlidesList'
import { getMessageLogo } from '../../../../helper/getMessageLogo'

import classes from './styles.module.scss'

class TemplateMessage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      leftScrollValue: 0,
      showReplies: true,
      currentIndex: 0,
      showScroll: false,
      additionalMargin: 12,
    }
    this.carousel = React.createRef()
    this.refTemplateList = []
  }

  componentDidMount() {
    const {
      message: { elements },
    } = this.props
    if (elements) {
      this.setState({ showScroll: this.scrollCounter() })
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.isFullScreenWidget !== this.props.isFullScreenWidget) {
      this.setState(
        {
          leftScrollValue: 0,
          showReplies: true,
          currentIndex: 0,
          showScroll: this.scrollCounter(),
        },
        () => (this.carousel.current.scrollLeft = 0),
      )
    }
  }

  nextItem = () => {
    this.scrollItems(true)
  }
  prevItem = () => {
    this.scrollItems(false)
  }
  scrollItems = next => {
    const { currentIndex, additionalMargin } = this.state
    const scrollValue = ReactDOM.findDOMNode(this.refTemplateList[currentIndex])
      ? ReactDOM.findDOMNode(
        this.refTemplateList[currentIndex],
      ).getBoundingClientRect().width + additionalMargin
      : ReactDOM.findDOMNode(
        this.refTemplateList[currentIndex - 1],
      ).getBoundingClientRect().width + additionalMargin

    let countedScrollValue =
      this.state.leftScrollValue + (next ? scrollValue : -scrollValue)
    const countedCurrentIndex = currentIndex + (next ? 1 : -1)
    if (!next) {
      countedScrollValue -= this.props.isFullScreenWidget ? additionalMargin : 0
    }

    this.setState(
      {
        leftScrollValue: countedScrollValue,
        currentIndex: countedCurrentIndex,
      },
      () => {
        this.carousel.current.scrollLeft = countedScrollValue
      },
    )
  }

  scrollCounter = () => {
    const {
      message: { elements, isFullScreenWidget },
    } = this.props
    let sumWidth = 0
    elements.forEach((slide, index) => {
      sumWidth += ReactDOM.findDOMNode(
        this.refTemplateList[index],
      ).getBoundingClientRect().width
    })
    sumWidth +=
      (elements.length - 1) *
      (isFullScreenWidget ? this.state.additionalMargin : 0)
    return this.carousel.current.offsetWidth < sumWidth
  }

  checkIfScrollShouldBeShowed = () => {
    const carousel = this.carousel.current
    return (
      carousel &&
      carousel.scrollWidth - carousel.offsetWidth >
        this.state.leftScrollValue + 20
    )
  }

  checkIfNeedRightArrow = slides => {
    const { currentIndex, showScroll, leftScrollValue } = this.state
    const { isFullScreenWidget } = this.props
    if (isFullScreenWidget) {
      return this.checkIfScrollShouldBeShowed() && showScroll
    } else {
      return (
        currentIndex < slides.length &&
        (this.checkIfScrollShouldBeShowed() || leftScrollValue === 0) &&
        showScroll
      )
    }
  }

  render() {
    const {
      postMessage,
      message,
      showLogo,
      showReply,
      device,
      settings,
      openIframe,
      isFullScreenWidget,
      isMobile,
    } = this.props
    const { currentIndex, leftScrollValue } = this.state
    const slides = message.elements
    const carousel = this.carousel.current
    const isLeftArrow = currentIndex > 0 && carousel && leftScrollValue > 0
    const isRightArrowNeeded = this.checkIfNeedRightArrow(slides)
    const { isRtl, isFromBot } = message
    const wrapClass =
      isFromBot && showLogo ? 'received-container_logo' : 'received-container'

    return (
      <>
        <div
          style={{ width: 'calc(100% - 26px)' }}
          className={classNames(wrapClass, 'msg--rcvd', 'full-screen-message')}>
          {isFromBot && showLogo ? (
            <div className="received-logo">
              <img
                width={32}
                height={32}
                src={getMessageLogo(message, settings)}
                alt=""
                className="bot-logo"
              />
            </div>
          ) : (
            <div className="received-not-logo" />
          )}
          <div style={{ width: '100%' }} className={classes.container}>
            {!isMobile && isLeftArrow && slides.length > 1 && (
              <div onClick={this.prevItem} className={classNames('generic-list-prev-btn', classes.prevIcon)}>
                <PrevIcon />
              </div>
            )}
            <div
              style={{
                width: `calc(100% - ${
                  isFullScreenWidget || showLogo ? 26 : 36
                }px)`,
                overflowX: isMobile ? 'scroll' : 'hidden',
              }}
              className={classes.scrollContainerFullScreen}
              ref={this.carousel}>
              <TemplateSlidesList
                slides={slides}
                isRtl={isRtl}
                device={device}
                settings={settings}
                openIframe={openIframe}
                postMessage={postMessage}
                refTemplateList={this.refTemplateList}
              />
            </div>
            {!isMobile && isRightArrowNeeded && slides.length > 1 && (
              <div
                className={classNames('generic-list-next-btn', classes.nextIcon, classes.nextIconFullScreen)}
                onClick={this.nextItem}>
                <NextIcon />
              </div>
            )}
          </div>
        </div>
        {showReply && (
          <QuickReplyList
            message={message}
            color={settings.color}
            postMessage={postMessage}
            isMobile={isMobile}
            isFullScreenWidget={isFullScreenWidget}
          />
        )}
      </>
    )
  }
}

TemplateMessage.propTypes = {
  isFullScreenWidget: PropTypes.bool,
  showLogo: PropTypes.bool.isRequired,
  showReply: PropTypes.bool.isRequired,
  message: PropTypes.object.isRequired,
  classes: PropTypes.object,
  openIframe: PropTypes.func.isRequired,
  postMessage: PropTypes.func.isRequired,
  device: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number,
  }),
  settings: PropTypes.shape({
    logo: PropTypes.string,
    color: PropTypes.string,
    title: PropTypes.string,
    bot_name: PropTypes.string,
    popup_text: PropTypes.string,
    popup_delay: PropTypes.number,
    greeting_text: PropTypes.string,
    chat_history_level: PropTypes.string,
    is_background_blurred: PropTypes.bool,
    enable_login_name_field: PropTypes.bool,
    enable_login_email_field: PropTypes.bool,
    is_composer_input_enabled: PropTypes.bool,
  }),
}

export default TemplateMessage
